export async function getWalletSignatureCookie(): Promise<string | null> {
  try {
    const cookie = await fetch('/cookies/wallet-signature', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const cookieResponse = await cookie.json();
    return cookieResponse.walletSignature;
  } catch (e) {
    console.error(e);
    return null;
  }
}
